export default __webpack_public_path__ + "images/mela-purchase/purple-tick-47a23cd2c00f34cbf82bfc97306e50df.svg";